// Port of api/fuel/app/classes/filter/search/games/filters/query/game/weight/average.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.weight.average',
	priority: 25,
	require: function(config, filter) {
		return rangeActive(filter.weight, 0, 5)
	},
	run: function(config, filter, data, query) {
		if (filter.weight.from > 0) query.where('g.game_weight_avg', '>=', filter.weight.from)
		if (filter.weight.to < 5) query.where('g.game_weight_avg', '<=', filter.weight.to)
		if (filter.threshold && filter.threshold.weight) {
			query.where('g.game_weight_count', '>=', filter.threshold.weight)
		}
	}
}
